module.exports = __webpack_public_path__ + "assets/media/navigations-google-play.8cf825d0.svg";